document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.has-mobile-slider').forEach(section => {
    const slides = section.querySelectorAll(':scope > *:not(.slider-dots)');
    const dotsContainer = section.parentElement.querySelector('[data-dots]');
    if (!dotsContainer || slides.length <= 1) return;

    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'dot';
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        section.scrollTo({
          left: slides[i].offsetLeft,
          behavior: 'smooth'
        });
      });
      dotsContainer.appendChild(dot);
    });

    section.addEventListener('scroll', () => {
      const scrollLeft = section.scrollLeft;
      const slideWidth = slides[0].offsetWidth;
      const index = Math.round(scrollLeft / slideWidth);
      dotsContainer.querySelectorAll('.dot').forEach((dot, i) =>
        dot.classList.toggle('active', i === index)
      );
    });
  });
});